import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const solicitudGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const colectiva = route.queryParamMap.get('colectiva');
  const certificado = route.queryParamMap.get('certificado');
  const estado = route.queryParamMap.get('estado');
  const numMovimiento = route.queryParamMap.get('numMovimiento');
  const tipoSolicitud = route.queryParamMap.get('tipoSolicitud');

  if (
    !colectiva || 
    !certificado || 
    !estado || 
    !numMovimiento || 
    !tipoSolicitud
  ) {
    router.navigate(['']);
    return false;
  }
  return true;
};

